import {
	Directive,
	DOCUMENT,
	ElementRef,
	inject,
	input,
	output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter, fromEvent, skipUntil, timer } from 'rxjs';

@Directive({
	selector: '[vc-click-outside]',
})
export class ClickOutsideDirective {
	private readonly elementRef = inject(ElementRef);
	private readonly _document = inject<Document>(DOCUMENT);

	excludeFromClosingRegex = input<RegExp | string | undefined>();
	clickOutside = output<MouseEvent>();

	constructor() {
		fromEvent(this._document, 'click')
			.pipe(
				// Delay as the click to open the dialog might not have been fully captured.
				skipUntil(timer(0)),
				takeUntilDestroyed(),
				filter((event: Event) => {
					const regex = this.excludeFromClosingRegex();
					if (regex !== undefined) {
						return !!(
							!this.elementRef.nativeElement.contains(
								event.target,
							) &&
							!RegExp(regex).exec(
								(event.target as HTMLElement)[
									'className'
								].toString(),
							)
						);
					}
					return !this.elementRef.nativeElement.contains(
						event.target,
					);
				}),
			)
			.subscribe((event) => {
				this.clickOutside.emit(event as MouseEvent);
			});
	}
}
